import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6709c4ca"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "menus-container" };
const _hoisted_2 = { class: "menu-item-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PrincipalMenuItem = _resolveComponent("PrincipalMenuItem");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (!menu.component)
                    ? (_openBlock(), _createBlock(_component_PrincipalMenuItem, {
                        key: 0,
                        menu: menu
                    }, null, 8, ["menu"]))
                    : (_openBlock(), _createBlock(_resolveDynamicComponent(menu.component), {
                        key: 1,
                        menu: menu
                    }, null, 8, ["menu"]))
            ]));
        }), 256))
    ]));
}
